var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineImageEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 192,
    viewBox: "0 0 288 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 192,
    fill: "#E8EAEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 60.5,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "#C7C7C7",
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 104V92C160 89.24 157.76 87 155 87H154C153.44 87 153 86.56 153 86C153 84.34 151.66 83 150 83H138C136.48 83 135.22 84.14 135.04 85.62L129.7 80.3C129.32 79.9 128.68 79.9 128.3 80.3C127.92 80.7 127.9 81.32 128.3 81.7L133.6 87H133.02C130.26 87 128.02 89.24 128.02 92V104C128.02 106.76 130.26 109 133.02 109H155.02C155.2 109 155.38 108.96 155.56 108.94L158.32 111.7C158.52 111.9 158.78 112 159.02 112C159.26 112 159.54 111.9 159.72 111.7C160.12 111.3 160.12 110.68 159.72 110.28L157.66 108.22C159.08 107.34 160.02 105.78 160.02 104H160ZM133 107C131.34 107 130 105.66 130 104V92C130 90.34 131.34 89 133 89H134C134.46 89 134.9 88.88 135.28 88.7L138.02 91.44C136.78 92.84 136 94.68 136 96.7C136 101.12 139.58 104.7 144 104.7C146.02 104.7 147.84 103.92 149.26 102.68L153.58 107H133ZM149.14 99.74L140.96 91.56C141.86 91.02 142.88 90.7 144 90.7C147.3 90.7 150 93.4 150 96.7C150 97.82 149.68 98.84 149.14 99.74ZM147.84 101.26C146.8 102.14 145.46 102.7 144 102.7C140.7 102.7 138 100 138 96.7C138 95.22 138.56 93.9 139.44 92.86L147.86 101.28L147.84 101.26ZM158 104C158 105.24 157.24 106.3 156.18 106.76L150.62 101.2C151.5 99.92 152.02 98.36 152.02 96.7C152.02 92.28 148.44 88.7 144.02 88.7C142.36 88.7 140.8 89.22 139.52 90.1L136.72 87.3C136.9 86.9 137.02 86.48 137.02 86.02C137.02 85.46 137.46 85.02 138.02 85.02H150.02C150.58 85.02 151.02 85.46 151.02 86.02C151.02 87.68 152.36 89.02 154.02 89.02H155.02C156.68 89.02 158.02 90.36 158.02 92.02V104.02L158 104Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineImageEmpty);
export default __webpack_public_path__ + "static/media/machineImageEmpty.951aff41f9a9a5a0d7d99646083f3f0c.svg";
export { ForwardRef as ReactComponent };